import { render } from "./PsychologistClients.vue?vue&type=template&id=557781d2"
import script from "./PsychologistClients.vue?vue&type=script&lang=js"
export * from "./PsychologistClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__